var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 13.6083C8.00839 13.6083 6.39172 11.9917 6.39172 10C6.39172 8.00833 8.00839 6.39166 10.0001 6.39166C11.9917 6.39166 13.6084 8.00833 13.6084 10C13.6084 11.9917 11.9917 13.6083 10.0001 13.6083ZM10.0001 7.64166C8.70006 7.64166 7.64172 8.7 7.64172 10C7.64172 11.3 8.70006 12.3583 10.0001 12.3583C11.3001 12.3583 12.3584 11.3 12.3584 10C12.3584 8.7 11.3001 7.64166 10.0001 7.64166Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5167C6.86669 17.5167 3.90836 15.6833 1.87502 12.5C0.991691 11.125 0.991691 8.88334 1.87502 7.5C3.91669 4.31667 6.87502 2.48334 10 2.48334C13.125 2.48334 16.0834 4.31667 18.1167 7.5C19 8.875 19 11.1167 18.1167 12.5C16.0834 15.6833 13.125 17.5167 10 17.5167ZM10 3.73334C7.30836 3.73334 4.73336 5.35 2.93336 8.175C2.30836 9.15 2.30836 10.85 2.93336 11.825C4.73336 14.65 7.30836 16.2667 10 16.2667C12.6917 16.2667 15.2667 14.65 17.0667 11.825C17.6917 10.85 17.6917 9.15 17.0667 8.175C15.2667 5.35 12.6917 3.73334 10 3.73334Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordOn);
export default __webpack_public_path__ + "static/media/password_on.b715b522b779e79f2963bc332cda2ee3.svg";
export { ForwardRef as ReactComponent };